export default function PageHeader({ title, subtitle, action }) {
  return (
    <header className="page-title-block">
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action && (
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
          {action}
        </div>
      )}
    </header>
  );
}
